import { api } from './client';
import type { MeResponse } from '@/types/User';

export interface LoginRequest {
  email: string;
  password: string;
}

export interface RegisterRequest {
  email: string;
  password: string;
  firstName: string;
  lastName: string;
}

export interface AuthResponse {
  authenticated: boolean;
  message?: string;
  error?: string;
}

export const authApi = {
  me: () => api<MeResponse>('/api/me'),
  login: (body: LoginRequest) =>
    api<AuthResponse>('/api/auth/login', {
      method: 'POST',
      body: JSON.stringify(body),
      // 401 здесь = неверные креды, а не истёкшая сессия — не дёргаем обработчик.
      skipAuthHandler: true,
    }),
  register: (body: RegisterRequest) =>
    api<AuthResponse>('/api/auth/register', {
      method: 'POST',
      body: JSON.stringify(body),
      skipAuthHandler: true,
    }),
  logout: () => api<void>('/logout', { method: 'POST' }),
};
